import { Space } from 'antd'
import { DatePicker } from 'antd'
import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { validateNotEmpty } from './utils'
import dayjs from 'dayjs'
import type { GetProps } from 'antd'
import customParseFormat from 'dayjs/plugin/customParseFormat'

interface DatePickerInputProps {
  required?: boolean
  source: string
  optionName?: string
  optionValue?: string
  disabled?: boolean
  validate?: (value: string | string[]) => string | undefined
  label?: string
  placeholder?: string
  autoSize?: Record<'minRows' | 'maxRows', number> | false
  handleOnChange?: (value: string | null) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
  onPressEnter?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
  format?: string
}

type RangePickerProps = GetProps<typeof DatePicker.RangePicker>

dayjs.extend(customParseFormat)

const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  // Can not select days before today and today
  return current && current < dayjs().endOf('day')
}

export const DatePickerInput: FC<DatePickerInputProps> = (props) => {
  const {
    source,
    disabled = false,
    validate,
    label = '',
    required = false,
    placeholder = 'Please enter',
    handleOnChange,
    format = 'MM/DD/YYYY',
  } = props
  const { control } = useFormContext()
  const { t } = useTranslation()

  return (
    <Space direction="vertical" size={0} style={{ width: '100%' }}>
      <label className="form-label">
        {t(label)}
        {required && <span className="text-danger"> *</span>}
      </label>
      <Controller
        control={control}
        name={source}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <div>
              <DatePicker
                disabled={disabled}
                disabledDate={disabledDate}
                format={format}
                placeholder={t(placeholder)}
                style={{ width: '100%' }}
                value={value}
                onChange={(e) => {
                  onChange(e)
                  if (handleOnChange) {
                    handleOnChange(e)
                  }
                }}
              />
              {error && <div style={{ color: 'red' }}>{error.message}</div>}
            </div>
          )
        }}
        rules={{
          validate: (value) => {
            if (required) {
              return validate ? validate(value) : validateNotEmpty(value)
            }
            return true
          },
        }}
      />
    </Space>
  )
}
